<template>
  <div class="view box grow" style="overflow-y: auto;">
    <page-headers
      header="Network Restrictions"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-network-restrictions"
      class="box"
    ></page-headers>
    <div class="full-height">
      <div class="table-toolbar" v-if="true">
        <table-toolbar
          :key="trailResponseBlockedNetworks.key"
          :search-properties="visibleColumns"
          :total-search-properties="columns"
          :search-data="trailResponseBlockedNetworks"
          :initial-tags="trailResponseBlockedNetworks.searchTags"
          :active-filter-data="activeFiltersData"
          :reload-component="trailResponseBlockedNetworks.reloadToolbar"
          :disable-search-box="disableSearchBox"
          @refresh-tabledata="fetchNetworkRestrictions"
          @update-querydata="updateTableQueryData"
          @update-columns-data="modifyColumnsData"
          @add-searchtags="addSearchTags"
          @deactivate-filter="deactivateFilter"
        >
          <div slot="left-toolbar-tools" class="filter-button-group">
            <span v-if="filterList.length">
              <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
                <el-input
                  ref="customFilterInput"
                  class="filter-input"
                  v-if="btn.editFlag"
                  placeholder="+Name"
                  v-model="btn.name"
                  @change.native.stop="handleFilterNameChange(btn)"
                  @keyup.native.enter="handleFilterNameChange(btn)"
                  @blur="handleFilterNameChange(btn)"
                ></el-input>
                <el-button
                  v-else
                  size="small"
                  round
                  :class="{'active': btn.active}"
                  :id="btn.id"
                  @click="changeState(btn)"
                >
                  {{ btn.name}}
                  <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                  <span>
                    <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                    <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                  </span>
                  </el-tooltip>
                </el-button>

                <span v-if="btn.errFlag" class="filter-name-validator">{{filterErrMsg}}</span>
              </div>
            </span>
          </div>
        </table-toolbar>
      </div>
      <action-table-element
        v-if="trailResponseBlockedNetworksStatus === 'completed'"
        ref="networkRestrictionsTable"
        class="network-restrictions-table"
        :columns="visibleColumns"
        :table-data="trailResponseBlockedNetworks"
        :height-offset="40"
        :actions="tableActions"
      ></action-table-element>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { networkRestrictionsMetaInfo } from '@/column-header/response_actions/network-restrictions-meta'
import { TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ, TRAIL_RESPONSE_ACTION_REQ, NETWORK_VIEW_PREFERENCES_REQ, SAVE_NETWORK_VIEW_PREFERENCES } from '@/store/modules/trails/trailsinfo.type'
import { AGENT_LIST_REQ } from '@/store/modules/agents/agents.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import { JIRA_TICKET_STATUS_CHANGE, JIRA_TICKET_FETCH_DETAILS } from '@/store/modules/jira/jira-setting.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ActionTableElement from '@/components/table/ActionTableElement.vue'

const DEFAULT_BLOCKED_NETWORKS_FILTER_HOURS = 5 * 365 * 24

export default {
  name: 'NetworkRestrictions',
  mixins: [loadDocumentationMixin, customFilterMixin],
  components: {
    PageHeaders,
    TableToolbar,
    ActionTableElement
  },
  data () {
    return {
      networkColumnPrefs: {},
      tableName: "Network",
      breadcrumbs: [{ title: 'Remediation' }, { title: 'Network Restrictions' }],
      columns: networkRestrictionsMetaInfo.meta.columns,
      // visibleColumns: networkRestrictionsMetaInfo.meta.columns,
      visibleColumns: [],
      tableActions: [
        {
          name: 'delete',
          icon: 'material-icons c-icon',
          iconSubject: 'lock',
          iconAlternate: 'restore_page',
          tooltip: 'Block',
          tooltipAlternate: 'Unblock',
          rbac: {
            subject: 'blocking-response',
            operation: 'write'
          },
          actionHandler: selection => {
            let vm = this
            let action = selection.row.action
            let message = action.includes('unblock-network')
              ? `Are you sure you want to unblock the network restriction?`
              : `Are you sure you want to block the network address?`
            this.$confirm(message, 'Confirm Action', {
              confirmButtonText: 'OK',
              cancelButtonText: 'Cancel',
              callback: function (action) {
                if (action === 'confirm') {
                  vm.restrictNetworkAction(selection.row)
                } else if (action === 'cancel') {
                  vm.$message({
                    type: 'info',
                    message: `Operation canceled`
                  })
                }
              }
            })
          }
        }
      ],
      tblId: 14
    }
  },
  created () {
    this.fetchNetworkRestrictions()
    this.loadNetworkColumnPreferences()
  },
  methods: {
    fetchNetworkRestrictions () {
      if (this.agentListReqStatus !== 'saved') {
        this.$store.dispatch(AGENT_LIST_REQ).then(resp => {
          this.$store
            .dispatch(TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ, DEFAULT_BLOCKED_NETWORKS_FILTER_HOURS)
            .then(collection => {
              this.updateTableQueryData()
            })
        })
      } else {
        this.$store
          .dispatch(TRAIL_RESPONSE_BLOCKED_NETWORKS_REQ, DEFAULT_BLOCKED_NETWORKS_FILTER_HOURS)
          .then(collection => {
            this.updateTableQueryData()
          })
      }
    },
    restrictNetworkAction (selection) {
      let email = this.userProfile.email
      let id = selection.recommendationHash.split(':')
      let action = selection.action
      let index = selection.recoIdx
      this.$store.dispatch(TRAIL_RESPONSE_ACTION_REQ, {
        trail_id: id.slice(0, 2).join(':'),
        ioc_hash: id[2],
        comment: action,
        assigned_from: email,
        owner_id: email,
        actions: [
          {
            index: index,
            action: action
          }
        ]
      }).then(_ => {
        let trailID = id.slice(0, 2).join(':')
        this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
          selectedTrail: trailID
        }).then(resp => {
          if (this.jiraTicketDetails !== 'None') {
            this.jiraActionHandler(trailID, this.jiraTicketDetails.status, action)
          }
        })
      })
    },
    updateTableQueryData () {
      if (this.$refs.networkRestrictionsTable) {
        this.$refs.networkRestrictionsTable.updateTableData()
      }
    },
    modifyColumnsData (selectedColumns) {
      this.networkColumnPrefs.userId = this.userProfile.id;
      this.networkColumnPrefs.tblName = this.tableName;
      this.networkColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.networkColumnPrefs.tblId = 14; // For Mapping with database tables

      this.visibleColumns = this.trailResponseBlockedNetworks.updateVisibleColumns(this.columns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_NETWORK_VIEW_PREFERENCES, this.networkColumnPrefs)
        .then(data => {
          // store preferences in vuex
          this.networkColumnPrefs.preferedCols = this.visibleColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.networkColumnPrefs);
        })
    },
    loadNetworkColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(NETWORK_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleColumns = this.columns.filter(col => {
              return this.networkPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.networkColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.networkColumnPrefs);
    },
    jiraActionHandler (trailId, statusType, commentForTicket) {
      let payload = {
        trail_id: trailId,
        status_type: statusType,
        comment_for_ticket: commentForTicket
      }
      this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload);
    }
  },
  computed: {
    ...mapGetters([
      'userProfile',
      'trailResponseActionStatus',
      'trailResponseBlockedNetworks',
      'trailResponseBlockedNetworksStatus',
      'agentListReqStatus',
      'networkPreferences',
      'userProfile',
      'networkCurrentUserPreference',
      'userPref',
      'jiraTicketDetails'
    ])
  },
  watch: {
    trailResponseActionStatus (newVal) {
      if (newVal === 'completed') {
        setTimeout(() => {
          this.fetchNetworkRestrictions()
        }, 500)
      }
    }
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 8%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/NetworkRestrictions.vue